import React from 'react'

const LivestreamOffline = () => (
    <p>Livestream offline</p>
)

export default LivestreamOffline
